import { useState } from "react";

import i18n from "../../constants/i18n";
import getCoreUIStore from "../../stores/core/core-ui-store";
import { TEt3Button } from "../../TypesNEW";
import { withLiteObserverAndTheme } from "../et3-enhanced-render";
import Et3Text from "../et3-text";
import Et3CustomizedButton from "./Et3CustomizedButton";
import {
  BUTTON_COMPACT_FONT_SIZE,
  BUTTON_COMPACT_HEIGHT,
  BUTTON_COMPACT_PADDING_X,
  BUTTON_COMPACT_RADIUS,
  BUTTON_DEFAULT_FONT_SIZE,
  BUTTON_DISABLED_BACKGROUND,
  BUTTON_HOVER_BRIGHTNESS,
  BUTTON_LARGE_FONT_SIZE,
  BUTTON_PRESS_OFFSET,
  BUTTON_RADIUS,
  BUTTON_RESTING_BRIGHTNESS,
  BUTTON_SHADOW,
  BUTTON_SHADOW_DISABLED,
  BUTTON_SHADOW_HOVER,
  BUTTON_TRANSITION
} from "./button-constants";

const Et3Button = withLiteObserverAndTheme<TEt3Button>((props) => {
  const { text, isEnabled, size, onClick, type, theme } = props;
  const { colors, unitX, unitY } = theme;
  const [isHovered, setIsHovered] = useState(false);
  const [isPressed, setIsPressed] = useState(false);
  const isButtonLocked = getCoreUIStore().buttonLocked.get();
  const fontType = "MEDIUM";
  const fontSize = (() => {
    switch (size) {
      case "LARGE":
        return BUTTON_LARGE_FONT_SIZE;
      case "COMPACT":
        return BUTTON_COMPACT_FONT_SIZE;
      default:
        return BUTTON_DEFAULT_FONT_SIZE;
    }
  })();
  const width = (() => {
    switch (size) {
      case "LARGE":
        return 280;
      case "MEDIUM":
        return 200;
      case "COMPACT":
        return 0;
      default:
        return 116;
    }
  })();
  const height = (() => {
    switch (size) {
      case "LARGE":
        return 45;
      case "MEDIUM":
      case "DEFAULT":
        return 40;
      case "COMPACT":
        return BUTTON_COMPACT_HEIGHT;
      default:
        return 39;
    }
  })();
  const radius = size === "COMPACT" ? BUTTON_COMPACT_RADIUS : BUTTON_RADIUS;
  const isButtonEnabled = isButtonLocked ? false : isEnabled;
  const color = (() => {
    switch (true) {
      case !isEnabled:
        return BUTTON_DISABLED_BACKGROUND;
      case type === "APPROVE":
        return colors.all.green;
      case type === "REJECT":
        return colors.all.red;
      case type === "GET":
        return colors.all.bondiBlue;
      case type === "WARN":
        return colors.all.darkOrange;
      case type === "SEND":
        return colors.all.bondiBlue;
      default:
        return colors.all.bondiBlue;
    }
  })();
  const labelColor = isEnabled ? colors.all.white : colors.all.dimGray;

  const isInteractive = isButtonEnabled && !isButtonLocked;
  const boxShadow = (() => {
    switch (true) {
      case !isInteractive:
        return BUTTON_SHADOW_DISABLED;
      case isHovered:
        return BUTTON_SHADOW_HOVER;
      default:
        return BUTTON_SHADOW;
    }
  })();

  let divStyle = {
    boxSizing: "border-box" as const,
    borderRadius: unitX * radius,
    boxShadow,
    filter:
      isInteractive && isHovered
        ? BUTTON_HOVER_BRIGHTNESS
        : BUTTON_RESTING_BRIGHTNESS,
    transform: `translateY(${
      isInteractive && isPressed ? BUTTON_PRESS_OFFSET * unitY : 0
    }px)`,
    transition: BUTTON_TRANSITION,
    cursor: isButtonLocked ? "default" : "pointer"
  };

  switch (size) {
    case "DEFAULT": {
      const divWidth = {
        width: "100%"
      };
      divStyle = { ...divStyle, ...divWidth };
      break;
    }
    case "COMPACT": {
      const divCompact = {
        width: "auto",
        minWidth: 0,
        paddingLeft: BUTTON_COMPACT_PADDING_X * unitX,
        paddingRight: BUTTON_COMPACT_PADDING_X * unitX,
        whiteSpace: "nowrap" as const
      };
      divStyle = { ...divStyle, ...divCompact };
      break;
    }
    default:
      break;
  }

  return (
    <Et3CustomizedButton
      withShadow={false}
      width={width}
      height={height}
      fDirection="row"
      alignItems="center"
      justifyContent="center"
      color={color}
      style={{
        ...divStyle
      }}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => {
        setIsHovered(false);
        setIsPressed(false);
      }}
      onMouseDown={() => setIsPressed(true)}
      onMouseUp={() => setIsPressed(false)}
      onClick={async () => {
        getCoreUIStore().buttonLocked.set(true);
        await onClick();
        getCoreUIStore().buttonLocked.set(false);
      }}
      isEnabled={isButtonEnabled}
    >
      <Et3Text
        fontFamily={fontType}
        fontSize={fontSize}
        text={i18n.get(text)}
        isSpan={false}
        color={labelColor}
        style={{ margin: 0 }}
      />
    </Et3CustomizedButton>
  );
});
export default Et3Button;
